import React from "react";
import "./FloatingButtons.css";
import {FaInstagram} from "react-icons/fa";

export default function FloatingButtons() {
  return (
    <div className="floating-buttons">
     

      <a
        href="https://www.instagram.com/sharp_dsgn/"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn instagram"
      > 
        <FaInstagram />
      </a>
      
    </div>
  );
}
